"use strict";
/* tslint:disable */
var TRegularPurchases = Object.assign({}, TBasePurchases, {
    buildInner: function (mode, purchase, context) {
        if (purchase.isEmpty() || purchase instanceof SPCashOutPurchase) {
            return '';
        } // dont display cashout bet receipts in the mobile for now
        var statusClass = Purchases.getStatusClass(purchase);
        var statusText = purchase.getStatusText();
        statusText += typeof purchase.getExternalIdText == 'function' ? purchase.getExternalIdText(' ') : '';
        context = context || {};
        var __html = '';
        __html += `
            <div class="bet_purchase_container ${Purchases.getStatus(purchase.PurchaseStatus)}">
                <div class="idBetsItem purchase_list_status ${Purchases.getStatus(purchase.PurchaseStatus)}">
                    <div class="betSlip_row_wrapper">
                        <div class="betSlip_row_content">
                            <div class="${statusClass} purchase_list_state">
                                ${statusText}
                            </div>
                            <div>
                                <div class="betSlip_row_desc">
                                    <strong>${purchase.getLinesDescription()}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="purchase_status_graphics">`;
        if (Purchases.isWaitingStatus(purchase.PurchaseStatus)) {
            __html += this.createLoader(statusClass);
        }
        else {
            __html +=
                `<div class="icon i-16 i-c-betslip-purchase ${Purchases.getStatus(purchase.PurchaseStatus)}"></div>`;
        }
        __html += `
                        </div>
                    </div>
                </div>
                ${this.createLinesList(mode, purchase, context)}
                ${this.createBetsList(mode, purchase, context)}
            </div>`;
        return __html;
    },
    createLinesListInner: function (mode, selections, context) {
        var selection, i, len, selectionType, keys = Object.keys(selections), skipEW = true, prevCombinatorGroup = "";
        var shouldShowOdds = !Modes.isTeaserMode(mode);
        if (BetSlip.isCombinatorMode(mode)) {
            selections.sort(function (a, b) { return a.compareCombinatorGroup(b, true); });
        }
        context.shouldShowEW = true;
        var __html = '';
        for (i = 0, len = keys.length; i < len; i += 1) {
            selection = selections[keys[i]];
            selectionType = BetSlipUtil.getSelectionType(selection);
            if (BetSlip.isCombinatorMode(mode) && prevCombinatorGroup !== selection.CombinatorGroup) {
                prevCombinatorGroup = selection.CombinatorGroup;
                var header = "{0} {1}:".format($dict.bs("CombinatorGroup"), prevCombinatorGroup);
                __html += `<div class="purchaseGroup">${header}</div>`;
            }
            __html += `
                <div class="idBetsItem placed purchaseLine">
                    <div class="betSlip_row_wrapper">
                        <div class="betSlip_row_content">
                            <div>
                                <strong>`;
            __html += TSelections[selectionType].buildPick(mode, selection, context, selections);
            __html += `
                                </strong>`;
            if (shouldShowOdds) {
                __html += TSlipShared.createPickLineOdds(mode, selection, context, skipEW);
            }
            __html += `
                            </div>
                            <div>
                                ${TSelections[selectionType].buildDescription(mode, selection, context, selections)}
                                ${TMinMax.createMinMaxForSingleSlipMode(mode, selection)}
                            </div>
                        </div>
                    </div>
                </div>`;
        }
        return __html;
    },
    createBetsListInner: function (mode, bets, context, purchase) {
        var bet, i, len, selection, keys = Object.keys(bets), selections, totalReturn, summary, taxesOnReturn;
        var __html = '';
        for (i = 0, len = keys.length; i < len; i += 1) {
            bet = bets[keys[i]];
            if (bet.skip && bet.skip(context)) {
                continue;
            }
            summary = context.VariationSummary;
            totalReturn = summary ? summary.maxWin : bet.getTotalGain();
            totalReturn = (bet.Selection && bet.Selection.EachWayIncluded) ? bet.getTotalGainEW() : totalReturn;
            taxesOnReturn = UserInfo.TaxProvider.getPurchaseTicketTaxAmount(totalReturn);
            //Ugly hack for forecast/tricast
            if (bet instanceof SPMultiLineBet) {
                selections = bet.ChildSelections;
            }
            __html += `
                <div class="idBetsItem placed purchaseReceipt">
                    <div class="betSlip_row_wrapper">
                        <div class="betSlip_row_content">
                            <div>
                                ${this.createBetTitle(bet)}
                                ${this.buildPick(mode, selection, context, selections, bet, purchase)}
                                ${this.buildComboBonusInfo(bet)}
                            </div>
                            <div>
                                <div class="betSlip_row_desc">
                                    ${this.buildDescription(mode, selection, context, selections, bet, purchase)}
                                    <div class="winnings">
                                        <strong>${$dict.bs("Stake")}:</strong>`;
            if (BetSlip.ShowNumberOfBetAfterSinglePurchaseOnMobile) {
                __html += `
                                            <span>${$dict.bs("SingleNamesOneBet")} x</span>`;
            }
            __html += `
                                        <span>
                                            ${this.createBetDeposit(bet, context)}
                                            ${this.createBetOdds(mode, bet, context)}
                                        </span>
                                        ${this.createFreeBetStake(bet, context)}
                                        <br/>
                                        <strong>${$string("BettingHistory").Return}:</strong>
                                        <span>${bet.getReturn(context)}</span>
                                        <br/><br/>`;
            if (taxesOnReturn) {
                var returnAfterTaxes = context.HasSP ? $dict.bs("NotAvailable") : (totalReturn - taxesOnReturn).toFixed(2);
                __html += `
                                            <div>${($dict.bs("RegulatoryTax")).format(UserInfo.TaxProvider.TaxInfo.CountryTax)}: ${UserInfo.current.toUserFormatedCurrencyString(taxesOnReturn)}</div>
                                            <div>${$dict.bs("ReturnAfterTax")}: ${UserInfo.current.toUserFormatedCurrencyString(returnAfterTaxes)}</div>`;
            }
            __html += `
                                        ${this.buildTaxOnDeposit(bet)}
                                     </div>
                                  </div>
                              </div>
                              ${this.buildLoyaltyPoints(bet)}
                        </div>
                    </div>
                </div>`;
        }
        __html += this.createNewOfferActions(bet);
        return __html;
    },
    createNewOfferActions: function (bet) {
        if (!Purchases.isNewOfferStatus(bet)) {
            return '';
        }
        return `
            <div class="betSlip_message success">
                ${TSlipShared.createLoader()}
                <span class="positive">${bet.StatusText}</span>
                <div class="arrowElementBorder"></div>
                <div class="arrowElement"></div>
                <div class="lineActions">
                    <a href="javascript:UniSlipBlock.declineOffer('${bet.RowID}');" class="flatBtn negative">${$dict.bs("Cancel")}</a>
                    <a href="javascript:UniSlipBlock.acceptOffer('${bet.RowID}');" class="flatBtn positive">${$dict.bs("Accept")}</a>
                </div>
            </div>
        `;
    }
});
window.TRegularPurchases = TRegularPurchases;
//# sourceMappingURL=TRegularPurchases.js.map